import script from "./LeaderboardScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderboardScreen.vue?vue&type=script&setup=true&lang=js"

import "./LeaderboardScreen.vue?vue&type=style&index=0&id=cc18f20a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc18f20a"]])

export default __exports__